<template>
    <div class="html-editor"  @click="checkScrum($event)">
        <div class="html-editor__buttons-block">
            <el-button @click="closeEditor()" >Закрыть</el-button>
            <el-button @click="updateBody(defaultValue)" v-if="!readOnly" type="success">Сохранить</el-button>
        </div>

        <medium-editor
            v-model="content"
            :readOnly="readOnly"
            :prefill="defaultValue"
            :options="options"
            :on-change="evt => $emit('on-change', evt)"
            v-on:uploaded="uploadCallback">
        </medium-editor>
    </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import Editor from "./Editor.vue";
export default {
  name: "app",

  props:{
    defaultValue: {
      default: '',
      type: String
    },
    readOnly:Boolean,
    pathToFile: String
  },

  data() {
    return {
      changeUrl: false,
      urlCreate: `/api/disciplines/${this.$route.params.did}/tpl`,
      urlUpdate: `/api/disciplines/${this.$route.params.did}/tpl/update`,
      content: ``,
      options: {
        uploadUrl: "https://api.imgur.com/3/image",
        uploadUrlHeader: {'Authorization': 'Client-ID db856b43cc7f441'},
        file_input_name: "image",
        imgur: true,
        toolbar: {
          buttons: ["italic",
          {
              name: 'bold',
              action: 'bold',
              aria: 'Жирный',
              contentDefault: '<b>B</b>',
          },
          {
              name: 'italic',
              action: 'italic',
              aria: 'Курсив',
              contentDefault: '<i>I</i>',
          },
           {
              name: 'justifyLeft',
              action: 'justifyLeft',
              aria: 'Выравнивание по левому краю',
              contentDefault: '<i class="fas fa-align-left"></i>',
              contentFA: '<i class="fas fa-align-left"></i>',
          },
          {
              name: 'justifyCenter',
              action: 'justifyCenter',
              aria: 'Выравнивание по центру',
              contentDefault: '<i class="fas fa-align-center"></i>',
              contentFA: '<i class="fas fa-align-center"></i>',
          },
          {
              name: 'justifyRight',
              action: 'justifyRight',
              aria: 'Выравнивание по правому краю',
              contentDefault: '<i class="fas fa-align-right"></i>',
              contentFA: '<i class="fas fa-align-right"></i>',
          },
          {
              name: 'justifyFull',
              action: 'justifyFull',
              aria: 'По всей ширине',
              contentDefault: '<i class="fas fa-align-justify"></i>',
              contentFA: '<i class="fas fa-align-justify"></i>',
          },
          {
              name: 'anchor',
              action: 'createLink',
              aria: 'Сылка',
              tagNames: ['a'],
              contentDefault: '<i class="fas fa-link"></i>',
              contentFA: '<i class="fa fa-link"></i>',
              attrs: {
                    'data-custom-attr': 'attr-value-h2'
              }
          },
           {
              name: 'underline',
              action: 'underline',
              aria: 'Подчёркивание',
              tagNames: ['u'],
              contentDefault: '<u>U</u>',
          },
          {
              name: 'quote',
              action: 'quote',
              aria: 'Цитата',
              tagNames: ['blockquote'],
              contentDefault: '" "',
          },
          {
              name: 'h1',
              aria: 'Заголовок первого уровня',
              contentDefault: 'H1',
          },
          {
              name: 'h2',
              aria: 'Заголовок второго уровня',
              contentDefault: 'H2',
          },
          {
              name: 'h3',
              aria: 'Заголовок третьего уровня',
              contentDefault: 'H3',
          },
          {
              name: 'h4',
              aria: 'Заголовок четвёртого уровня',
              contentDefault: 'H4',
          },
          {
              name: 'unorderedlist',
              aria: 'Маркированный список',
              contentDefault: '<b>•</b>',
          },
          {
              name: 'orderedlist',
              aria: 'Нумерованный список',
              contentDefault: '<b>1.</b>',
          }
          ]
        }
      }
    };
  },

  components: {
    "medium-editor": Editor
  },
  methods: {
    ...mapMutations(['setHtmlEditorActive']),
    ...mapActions(['updateFile']),
    checkScrum(e){
      e.preventDefault();
      if(e.target.tagName==='A' && !this.changeUrl){
        let stringHtttp = e.target.href.split('/').reverse()[0]
        if(stringHtttp === 'play.php' || stringHtttp === 'play.html'){
         window.open(`https://college.instudy.online/course/player/play.php?discpl=${this.$route.params.did}`)
          this.changeUrl = true
        }else{
          window.open(e.target.href)
        }
       }else{
         return
       }
    },
    updateBody(value){
       let path = value ?  this.urlUpdate : this.urlCreate
      let data={
        status: value ? 'update' : 'create',
        path: value ? this.pathToFile : this.pathToFile + '/content.tpl',
        body: this.content ? this.content : this.defaultValue
      }
      this.updateFile({path, data}).then(res=>{
        this.notify(res.status, res.message)
      })
    },
    closeEditor(){
      this.setHtmlEditorActive(false)
    },

    uploadCallback(url) {
        console.info("uploaded url", url)
    },
    notify(status, text){
        const h = this.$createElement
        this.$notify({
          title: '',
          message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
        });
    },
  },
  mounted(){
    let container = document.querySelector('.html-editor')
    let links = container.querySelectorAll('a')
    links.forEach(el=>el.setAttribute('target', 'blank'))
  }
};
</script>

<style lang="css">
/* @import "~bulma/css/bulma.css"; */
@import "~medium-editor/dist/css/medium-editor.css";
@import "./themes/default.css";
/*@import '~highlight.js/styles/github.css';*/
/*@import '~highlight.js/styles/ocean.css';*/
@import '~highlight.js/styles/ocean.css';
.html-editor{

}
.html-editor__buttons-block{
  margin: 20px
}
</style>
